import Slider from "react-slick";
import ProductCard from "../ProductCard";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { useEffect, useState } from "react";

// Next arrow
const NextArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    className="absolute -right-3 top-1/2 -translate-y-1/2 z-10 bg-white rounded-full p-2 shadow-md hover:bg-black hover:text-white transition"
  >
    <FiChevronRight size={20} />
  </button>
);

// Prev arrow
const PrevArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    className="absolute -left-3 top-1/2 -translate-y-1/2 z-10 bg-white rounded-full p-2 shadow-md hover:bg-black hover:text-white transition"
  >
    <FiChevronLeft size={20} />
  </button>
);

const NewIn = ({ products }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Recalculate on resize
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Determine slidesToShow dynamically
  let slidesToShow = 4; // default desktop
  if (windowWidth < 480) slidesToShow = 1;
  else if (windowWidth < 768) slidesToShow = 2;
  else if (windowWidth < 1024) slidesToShow = 3;

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  // Force remount when slidesToShow changes to fix Slick quirk
  const sliderKey = `slider-${slidesToShow}`;
const reorderedProducts = [...products];
if (reorderedProducts.length > 1) {
  // Swap first and second
  [reorderedProducts[0], reorderedProducts[1]] = [reorderedProducts[1], reorderedProducts[0]];
}
  return (
    <div className="w-full overflow-hidden">
      <h2 className="text-3xl font-light text-center mb-10 tracking-wide">
        New In
      </h2>

      <Slider {...settings} key={sliderKey}>
      

         {reorderedProducts.map((product) => (
    <div key={product.id || product._id} className="px-2 sm:px-1">
      <ProductCard product={product} />
    </div>
  ))}
      </Slider>
    </div>
  );
};

export default NewIn;